export default __webpack_public_path__ + "static/logos-864cfe544ae19603a161a98dcb6ac194.jpg";